/* tslint:disable:no-inferrable-types no-trailing-whitespace import-spacing typedef-whitespace align whitespace quotemark */


import { DocumentWindow }        from './document.window';
import { DocumentWindowManager } from './document.window.manager';
import { Logger }                from '@/util/logger';

import { BlobService }           from '@/services/blob.service';
import { AuthenticationService}  from '@/services/authentication.service';
import { IdeService}             from '@/services/ide.service';
import { TextEditorMetadata }    from './text.editor.metadata';

import * as $                    from 'jquery';

import {Ace, edit} from 'ace-builds';
import {first} from "rxjs/operators";
import Editor = Ace.Editor;

/**
 *
 * @class TextEditorWindow
 *
 * @brief window for just basic text editing; CSV files or whatever.
 *
 * @link https://ace.c9.io/#nav=embedding
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      April 2020
 *
 */
export class TextEditorWindow extends DocumentWindow {

  /** access to the virtual file system */
  private blobber:           BlobService = null;

  /** access to user authentication */
  private auth:    AuthenticationService = null;

  /** access to user authentication */
  private ide:                IdeService = null;

  /** the document manager we are a tab  of */
  private manager: DocumentWindowManager = null;

  /** the current search pattern */
  private key:                 string = '';

  /** the editor mode */
  private mode:                string = 'json';

  /** the actual editor */
  private editor:              Editor = null;

  /** standard constructor */
  constructor(
    meta: TextEditorMetadata,
    manager: DocumentWindowManager
  ) {

    super(manager, meta, manager.layoutManager());

    Logger.debug('[TextEditorWindow] constructing...');

    this.manager     = manager;
    this.auth        = this.manager.authService();
    this.blobber     = this.manager.blobService();
    this.ide         = this.manager.ideService();
    this.key         = meta.key;
    this.mode        = meta.mode;

    this.showBrowser();
  }

  /** restore the search view (on current 'focus') */
  public showBrowser() {

    Logger.debug(`[TextEditorWindow] => ${this.key} : ${this.mode} ...`);

    const container: JQuery<HTMLElement> = $(`#${this.meta.id}`);

    if (!$(container) || !$(container).is('div')) {

      this.unReady();

      Logger.error(`[TextEditorWindow] missing hosting container (${this.meta.id})!`);

      return ;
    }

    $(container).html(`
<div id="ace_editor_${this.meta.id}" class="">
</div>
`);

    const checkExist = setInterval(() => {

      const dom: HTMLElement = document.getElementById(`ace_editor_${this.meta.id}`) as HTMLElement;

      if (dom) {

        clearInterval(checkExist);

        $(dom).css('height', '100%');

        Logger.debug(`[TextEditorWindow] init ...`);

        this.editor = edit(`ace_editor_${this.meta.id}`);

        this.editor.session.setMode("ace/mode/text");

        this.loadBlobKey(this.key, this.mode);
      }

    }, 100);
  }

  private loadBlobKey(key: string, mode: string): void {

    if (key.trim() === '') {

      Logger.debug(`[TextEditorWindow] loading (empty).`);

      /* just clear the editor */

      this.editor.setValue('{}');

      return ;
    }

    if (this.mode == 'rawtext') {

      /* we don't have to load a blob by key, its just text to show in the window */

      Logger.debug(`[TextEditorWindow] showing text...`);

      try {

        this.editor.setValue(this.key);

        this.editor.focus();

      } catch(error) {

        Logger.error(`[TextEditorWindow] problem loading JSON: `, error);
      }

      return ;
    }

    Logger.debug(`[TextEditorWindow] loading: `, key);

    this.blobber.contents(key)
      .pipe(first())
      .subscribe(
        (content: string) => {

          try {

            this.editor.setValue(content);

            this.editor.focus();

          } catch(error) {

            Logger.error(`[TextEditorWindow] problem loading JSON: `, error);
          }
        },
        (error) => {

          Logger.error(`[TextEditorWindow] can't find content ${key}: `, error);
        });

  }

  /** update the focus to current */
  private updateFocus(key: string, mode: string): void {

    this.mode   = mode;
    this.key    = key;

    let keyBase = key.substring(key.lastIndexOf('/') + 1);

    if(!keyBase || keyBase === '' ) {

      keyBase = key;
    }

    this.title  = `${keyBase}`;

    this.editor.focus();
  }

}
